// Tempos máximos pra resposta dos atores no fluxo de um pedido.
// Locador tem 30min (consulta agenda, físico). Freteiro tem 60s (decisão rápida,
// estilo Uber — alinhado com o TTL real da oferta no backend). Se expirar,
// o pedido segue pro próximo elegível na fila.

export const CONFIG_TIMEOUT = {
  locador: {
    tempoTotal: 30,                    // 30 minutos para aceitar (fluxo presencial + consultas)
    alertaEm: 50,                      // Alerta aos 50% do tempo (15 min)
    mensagemAlerta: 'Você tem um pedido pendente! Responda para não perder a locação.',
  },
  freteiro: {
    tempoTotal: 60,                    // 60 segundos para aceitar (= TTL da oferta no backend)
    rotacaoAutomatica: true,           // Mover para próximo se expirar/recusar
  },
  maxTentativasFreteiro: 5,
  incrementoOferta: 15,
};
